export const DEFAULT_FISHING_STATE = {
  loading: false,
  fishing: [],
};
